"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class Issue extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'issue';
        this._gatewayId = initParams.gateway_id;
        this._siteId = initParams.site_id;
        this._assetName = initParams.asset_name;
        this._gatewayName = initParams.gateway_name;
        this._siteName = initParams.site_name;
        this._name = initParams.name;
        this._assetDisconnected = initParams.asset_disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._assetDisconnectedTs = initParams.asset_disconnected_ts;
        this._gatewayDisconnectedTs = initParams.gateway_disconnected_ts;
        this._assetIntermittent = initParams.asset_intermittent;
        this._gatewayIntermittent = initParams.gateway_intermittent;
        this._assetLowSignal = initParams.asset_low_signal;
        this._gatewayLowSignal = initParams.gateway_low_signal;
        this._assetLowBattery = initParams.asset_low_battery;
        this._assetFault = initParams.asset_fault;
        this._gatewayFault = initParams.gateway_fault;
        this._assetAnomaly = initParams.asset_anomaly;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    get gatewayId() {
        return this._gatewayId;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set assetName(value) {
        console.error('Do not set objects this way');
    }
    get assetName() {
        return this._assetName;
    }
    set gatewayName(value) {
        console.error('Do not set objects this way');
    }
    get gatewayName() {
        return this._gatewayName;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    get siteName() {
        return this._siteName;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set assetDisconnected(value) {
        console.error('Do not set objects this way');
    }
    get assetDisconnected() {
        return this._assetDisconnected;
    }
    set gatewayDisconnected(value) {
        console.error('Do not set objects this way');
    }
    get gatewayDisconnected() {
        return this._gatewayDisconnected;
    }
    set assetDisconnectedTs(value) {
        console.error('Do not set objects this way');
    }
    get assetDisconnectedTs() {
        return this._assetDisconnectedTs;
    }
    set gatewayDisconnectedTs(value) {
        console.error('Do not set objects this way');
    }
    get gatewayDisconnectedTs() {
        return this._gatewayDisconnectedTs;
    }
    set assetIntermittent(value) {
        console.error('Do not set objects this way');
    }
    get assetIntermittent() {
        return this._assetIntermittent;
    }
    set gatewayIntermittent(value) {
        console.error('Do not set objects this way');
    }
    get gatewayIntermittent() {
        return this._gatewayIntermittent;
    }
    set assetLowSignal(value) {
        console.error('Do not set objects this way');
    }
    get assetLowSignal() {
        return this._assetLowSignal;
    }
    set gatewayLowSignal(value) {
        console.error('Do not set objects this way');
    }
    get gatewayLowSignal() {
        return this._gatewayLowSignal;
    }
    set assetLowBattery(value) {
        console.error('Do not set objects this way');
    }
    get assetLowBattery() {
        return this._assetLowBattery;
    }
    set assetFault(value) {
        console.error('Do not set objects this way');
    }
    get assetFault() {
        return this._assetFault;
    }
    set gatewayFault(value) {
        console.error('Do not set objects this way');
    }
    get gatewayFault() {
        return this._gatewayFault;
    }
    set assetAnomaly(value) {
        console.error('Do not set objects this way');
    }
    get assetAnomaly() {
        return this._assetAnomaly;
    }
}
exports.default = Issue;
//# sourceMappingURL=issue.js.map